export default __webpack_public_path__ + "static/media/arrow-down.fedd97d4.svg";